<script setup lang="ts">
import type { SizeVariants } from '~kui/types/kui';

import { Spinner } from '~ds/components/ui/spinner';

interface Props {
  size?: Extract<SizeVariants, '2xs' | 'xs' | 'sm' | 'md' | 'lg'>;
  text?: string | undefined;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'lg',
  text: undefined,
});

// The branded record loader is the DS Spinner rotating the Anyway record
// illustration (the capability the DS Spinner was built for). Keep the KUI
// size scale exact; the illustration fills the sized Spinner box.
const sizeClass = computed(() => ({
  '2xs': 'size-2',
  'xs': 'size-3',
  'sm': 'size-6',
  'md': 'size-12',
  'lg': 'size-24',
}[props.size]));
</script>

<template>
  <div
    class="flex flex-col items-center"
    role="status"
    aria-live="polite"
    :aria-label="text || 'loading'"
  >
    <Spinner
      data-testid="loader-anyway"
      aria-hidden="true"
      :class="sizeClass"
    >
      <NuxtImg src="/images/kui/anyway-record.webp" class="aspect-square object-cover" />
    </Spinner>
    <p v-if="text" class="mt-3 font-medium">
      {{ text }}
    </p>
  </div>
</template>
